export const CONTRACT_TYPE_GET_REQUEST = 'CONTRACT_TYPE_GET_REQUEST';
export const CONTRACT_TYPE_GET_SUCCESS = 'CONTRACT_TYPE_GET_SUCCESS';
export const CONTRACT_TYPE_GET_ERROR = 'CONTRACT_TYPE_GET_ERROR';
export const CONTRACT_TYPE_GET_BY_KEY_REQUEST = 'CONTRACT_TYPE_GET_BY_KEY_REQUEST';
export const CONTRACT_TYPE_GET_BY_KEY_SUCCESS = 'CONTRACT_TYPE_GET_BY_KEY_SUCCESS';
export const CONTRACT_TYPE_GET_BY_KEY_ERROR = 'CONTRACT_TYPE_GET_BY_KEY_ERROR';
export const CONTRACT_TYPE_ADD_REQUEST = 'CONTRACT_TYPE_ADD_REQUEST';
export const CONTRACT_TYPE_ADD_SUCCESS = 'CONTRACT_TYPE_ADD_SUCCESS';
export const CONTRACT_TYPE_ADD_ERROR = 'CONTRACT_TYPE_ADD_ERROR';
export const CONTRACT_TYPE_EDIT_REQUEST = 'CONTRACT_TYPE_EDIT_REQUEST';
export const CONTRACT_TYPE_EDIT_SUCCESS = 'CONTRACT_TYPE_EDIT_SUCCESS';
export const CONTRACT_TYPE_EDIT_ERROR = 'CONTRACT_TYPE_EDIT_ERROR';
export const CONTRACT_TYPE_DELETE_REQUEST = 'CONTRACT_TYPE_DELETE_REQUEST';
export const CONTRACT_TYPE_DELETE_SUCCESS = 'CONTRACT_TYPE_DELETE_SUCCESS';
export const CONTRACT_TYPE_DELETE_ERROR = 'CONTRACT_TYPE_DELETE_ERROR';

export const CONTRACT_TYPE_ID_GOVERNMENT_REQUESTS = 5;